






















































































































































import {
  defineComponent,
  useContext,
  ref,
  inject,
  useStore,
  onMounted,
  PropType,
  useRouter,
  computed,
  toRef,
  Ref
} from '@nuxtjs/composition-api'
import { formatDate } from '@/utils/date'
import AppointmentType from '~/models/AppointmentType'
import StoreCredit from '~/models/StoreCredit'
import SubscriptionFeature from '~/models/SubscriptionFeature'
import { StoryblokComponent } from '~/types/storyblok-vue'
import AppointmentRoom from '~/models/AppointmentRoom'

export interface OrderSummary extends StoryblokComponent<'OrderSummary'> {
  content: StoryblokComponent<any>[]
  custom_classes: string
  title: string
}

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<OrderSummary>,
      default: () => {}
    }
  },
  setup() {
    const { $axios, $bus, $dayjs, $config, localePath } = useContext()
    const store = useStore()
    const voucher = ref('')
    const isVoucherValid = ref(false)
    const message = ref('')
    const newPrice = ref(0)
    const userData = inject('userData', ref({ subscriptions: [] }))
    const dataModel: any = inject('dataModel', {})
    const item: Ref<AppointmentRoom> = toRef(dataModel, 'room')
    const appointmentType = computed(() =>
      store.$repo(AppointmentType).with('product').find(item.value?.appointmentTypeID)
    )
    const loggedIn = computed(() => store.state.auth.loggedIn)
    const planFeatureTag =
      appointmentType.value && appointmentType.value.product ? appointmentType.value.product.plan_feature_tag : ''
    const subCount = ref(0)
    const creditCount = ref(0)
    const isFree = ref(false)
    const featureUsageOverall = ref(0)
    const featureUsageUsed = ref(0)
    const isBusy = ref(false)
    const router = useRouter()

    const submitVoucher = async () => {
      const payload = {
        code: voucher.value,
        data: {
          classId: item.value.id
        }
      }
      const response = await $axios
        .post(`/api/payment/voucher/check`, payload)
        .then((response) => response.data)
        .catch((e) => {
          console.error(e.message)
          message.value = e.message
        })
      if (response?.success) {
        isVoucherValid.value = true
        message.value = response.message
        newPrice.value = response.data.reward
      }
    }

    const checkout = async (id) => {
      const payload = {
        classId: id,
        timezone: $dayjs.tz.guess(),
        redirectUrlSuccess: $config.api + localePath('/confirmation'),
        redirectUrlCancel: $config.api + localePath('/confirmation_cancel')
      }
      if (loggedIn.value) {
        await $axios
          .$post(`/api/payment/order/booking`, payload)
          .then((response) => (window.location.href = response.data.redirect_url))
      } else {
        router.push('login')
      }
    }

    const goToCreditPage = () => {
      $bus.emit('closeFormModal')
      const currentPath = router.history.current.fullPath
      if (currentPath.includes('fifa')) {
        router.push(localePath('/games/fifa/pricing-credits'))
      }
      if (currentPath.includes('fortnite')) {
        router.push(localePath('/games/fortnite/pricing-credits'))
      }
      if (currentPath.includes('leagueoflegends')) {
        router.push(localePath('/games/leagueoflegends/pricing-credits'))
      }
    }

    const checkSubscriptionStatus = () => {
      if (userData.value && userData.value.subscriptions && userData.value.subscriptions.length > 0) {
        const planFeature = store
          .$repo(SubscriptionFeature)
          .with('usage')
          .where('tag', planFeatureTag)
          .where('plan_subscription_id', userData.value.subscriptions[0].id)
          .first()
        if (planFeature && planFeature.value) {
          if (planFeature.value === ('true' || 'false')) {
            isFree.value = planFeature.value === 'true'
          } else {
            featureUsageOverall.value = parseInt(planFeature.value)
            featureUsageUsed.value = parseInt(planFeature.usage?.used) || 0
            isFree.value = featureUsageOverall.value > featureUsageUsed.value
            subCount.value = featureUsageOverall.value - featureUsageUsed.value
          }
        }
      }
    }

    const checkCredits = () => {
      if (userData.value && userData.value.store_credits && userData.value.store_credits.length > 0) {
        const storeCredits = store.$repo(StoreCredit).where('product_tag', planFeatureTag).where('usage', false).get()
        creditCount.value = storeCredits.length
      }
    }

    onMounted(() => {
      document.body.classList.add('overflow-hidden')
      checkSubscriptionStatus()
      checkCredits()
    })

    return {
      formatDate,
      voucher,
      submitVoucher,
      isVoucherValid,
      checkout,
      goToCreditPage,
      message,
      newPrice,
      checkSubscriptionStatus,
      isFree,
      isBusy,
      subCount,
      creditCount,
      item,
      dataModel
    }
  }
})
